import { useState } from "react";
import { useCentralStore } from "stores";

const DEFAULT_MAX_FILE_SIZE = 1.01;

export const useFileUpload = (options = {}) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileError, setFileError] = useState("");
  const setNotification = useCentralStore(state => state.setNotification);

  const maxFileSizeMB = options.maxFileSizeMB || DEFAULT_MAX_FILE_SIZE;
  const maxFileSizeBytes = maxFileSizeMB * 1024 * 1024;

  const validateFileSize = file => {
    if (!file) return true;

    if (file.size > maxFileSizeBytes) {
      const errorMessage = `File size exceeds ${Math.floor(
        maxFileSizeMB
      )}MB limit`;

      setNotification({
        type: "error",
        title: "File size too large",
        message: `${errorMessage}. Please select a smaller file.`
      });

      setFileError(errorMessage);
      return false;
    }

    setFileError("");
    return true;
  };

  const handleFileChange = event => {
    const file = event.target.files[0];

    if (file && validateFileSize(file)) {
      setSelectedFile(file);
    } else {
      setSelectedFile(null);
    }
  };

  const openFileDialog = () => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");

    if (options.accept) {
      input.setAttribute("accept", options.accept);
    }

    input.addEventListener("change", handleFileChange);
    input.click();
  };

  const resetFile = () => {
    setSelectedFile(null);
    setFileError("");
  };

  return [selectedFile, openFileDialog, resetFile, fileError];
};
